import { Component, OnInit, ElementRef, Injector, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Component wrapper for UserFieldsController
 */
@Component({
  selector: 'user-fields-list',
  template: '<user-fields-list-directive></user-fields-list-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserFieldsListComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    // No specific route params needed for user fields list component
  }
}

/**
 * Directive for downgrading UserFieldsListComponent
 */
@Component({
  selector: 'user-fields-list-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserFieldsListDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('userFieldsList', elementRef, injector);
  }
}

/**
 * Component wrapper for UserFieldController
 */
@Component({
  selector: 'user-field-form',
  template: '<user-field-form-directive [id]="id" [template]="template"></user-field-form-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserFieldFormComponent implements OnInit {
  @Input() id: string;
  template: any;

  router = inject(Router);
  route = inject(ActivatedRoute);

  constructor() {}

  ngOnInit() {
    // Subscribe to route params to get the template data from query params
    this.route.queryParams.subscribe((params) => {
      try {
        if (params['template']) {
          this.template = JSON.parse(params['template']);
        }
      } catch (e) {
        console.error('Error parsing template data', e);
      }
    });
  }
}

/**
 * Directive for downgrading UserFieldFormComponent
 */
@Component({
  selector: 'user-field-form-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserFieldFormDirective extends UpgradeComponent {
  @Input() id: string;
  @Input() template: any;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('userFieldForm', elementRef, injector);
  }
}

/**
 * Component wrapper for UserFieldsReorderController
 */
@Component({
  selector: 'user-fields-reorder',
  template: '<user-fields-reorder-directive></user-fields-reorder-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserFieldsReorderComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    // No specific route params needed for user fields reorder component
  }
}

/**
 * Directive for downgrading UserFieldsReorderComponent
 */
@Component({
  selector: 'user-fields-reorder-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserFieldsReorderDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('userFieldsReorder', elementRef, injector);
  }
}
